export default __webpack_public_path__ + "static/media/francheville11.43ff2575.jpg";